import Attachment from "./Attachment";
export { default as confirmDelete } from "./confirmDelete";
export default Attachment;